<template>
  <v-menu v-model="showEdit" :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        plain
        @click="showEdit = !showEdit"
        class="text-none input-change"
      >
        {{ items[label] }}
      </v-btn>
    </template>

    <v-card>
      <v-container class="filter-text">
        <v-text-field v-model="itemsForms[label]" label="Editar"></v-text-field>
      </v-container>
      <v-card-actions>
        <v-btn small color="primary" @click="showEdit = false" text>
          Cancelar
        </v-btn>
        <v-btn small color="primary" @click="updateLogins(items)" text>
          Editar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>
<script>
import logins from "@/services/http/rpa/Logins";
import toast from "@/commom/toast";

export default {
  props: {
    label: {
      type: String,
    },
    portal: {
      type: Object,
    },
    items: {
      type: Object,
    },
  },
  data() {
    return {
      itemsForms: {
        login: this.items.login,
        password: this.items.password,
        descricao: this.items.descricao,
        rpa_portal_acesso_id: this.portal.id,
      },
      showEdit: false,
    };
  },
  methods: {
    async updateLogins() {
      try {
        let data = {};
        data[this.label] = this.itemsForms[this.label];
        await logins(this.items.id).update(data);
        toast("success", "Credenciais atualizadas");
        this.showEdit = false;
      } catch (err) {
        console.log(err);
        toast("error", "Erro inesperado");
      } finally {
        this.$emit("updateTableLogins");
      }
    },
  },
};
</script>
<style scoped>
.input-change {
  font-size: 0.875rem !important;
  font-weight: 400;
  height: 48px important;
  color: rgba(0, 0, 0, 0.87) !important;
}
</style>
